import React from "react";

// Lazy-load per family
const LabyrinthScarfReadback = React.lazy(() => import("./LabyrinthScarfReadback"));
const HopeBlanketsReadback = React.lazy(() => import("./HopeBlanketsReadback"));
// const CryptiqueReadback = React.lazy(() => import("./CryptiqueReadback"));

/**
 * Exact mapping by product_families.type
 * This should match the DB value exactly.
 */
const READBACKS_BY_TYPE = {
  labyrinth_scarf: LabyrinthScarfReadback,
  hope_blanket: HopeBlanketsReadback,
  // cryptique: CryptiqueReadback,
};

export function getReadbackComponent(familyType) {
  if (!familyType) return null;
  return READBACKS_BY_TYPE[familyType] ?? null;
}
